import * as React from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { columns, rows } from './helper_row_column';
import { WrapperGrid } from './styles';

const TableComparative = () => {
  return ( 
    <WrapperGrid>
      <strong>Tabla Deduciones</strong>
      <Box  
        sx={{
          height: 450,
          width: '100%',
          boxShadow: 2,
          borderColor: 'primary.light',
          '& .super-app-theme--header': {
            backgroundColor: 'gray',
            color: 'white'
          },

        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={6}
          rowsPerPageOptions={[6]}
        />
      </Box>
    </WrapperGrid>
  );
}
 
export default TableComparative;